import { z } from 'zod';
export const onboardingPathSchema = z.enum(['start_fresh', 'move_in', 'connect']);
export const generalLedgerPlatformSchema = z.enum([
    'quickbooks',
    'appfolio',
    'yardi',
    'buildium',
    'rent_manager',
    'other',
]);
export const onboardingModuleSchema = z.enum(['general_ledger', 'payments']);
export const moduleStatusSchema = z.enum(['not_set_up', 'set_up_later', 'in_setup', 'live']);
export const billedBySchema = z.enum(['teo', 'their_system']);
export const BILLED_BY_FOR_PATH = {
    start_fresh: 'teo',
    move_in: 'teo',
    connect: 'their_system',
};
export const organizationSettingSchema = z.enum([
    'profile',
    'preferences',
    'permissions',
    'invoice_message',
    'communication',
    'chart_of_accounts',
    'billing_setup',
    'general_ledger',
    'payments',
    'bank_accounts',
]);
export const settingStatusSchema = z.enum(['done', 'not_set_up', 'needs_attention']);
//# sourceMappingURL=onboarding.js.map